import { render, staticRenderFns } from "./ModalDialogChangePassword.vue?vue&type=template&id=38c76c88&"
import script from "./ModalDialogChangePassword.vue?vue&type=script&lang=js&"
export * from "./ModalDialogChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalDialogChangePassword.vue?vue&type=style&index=0&id=38c76c88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports